<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {uri} from "@/constants/config.js";
import InputText from "@/base-components/Form/InputText.vue";
import {Form} from "vee-validate";
import {ref} from "vue";
import {object} from "yup";
import {useFetch} from "@/composables/useFetch.js";
import useValidate from "@/composables/useValidate.js";
import {useI18n} from "vue-i18n";
import {toast} from "vue3-toastify";
import BaseInputSelect from "@/base-components/Form/BaseInputSelect.vue";

const props = defineProps({
  isUpdate: {
    type: Boolean,
    default: false
  },
  item: {
    type: Object,
    required: true
  },
  show: {
    type: Boolean,
    default: false
  }
})
const {t: $t} = useI18n()
const emit = defineEmits(['close', 'onSuccess']);

function close() {
  emit('close')
}

const slug = ref(null)
const data = null;
const date = "";

const loadingFlag = ref(false);
const errorMessage = ref('');

const successMessage = ref('');
const mobile = ref(null)
const otp = ref(null)

const authTypes = [
  {value: "PERMISSION", title: "Permission"},
  {value: "TASK", title: "Task"},
  {value: "ROLE", title: "Role"},
]
const form = ref({
  name: props.item.name || "",
  attributes: props.item.attributes || [],
  type: Object.assign({},authTypes.find(x => x.value === props.item.type) ||authTypes[0])
})

const validationSchemaRegister = object(useValidate(['name']),)


async function register() {
  loadingFlag.value = true;
  successMessage.value = '';
  errorMessage.value = '';
  form.value.type = authTypes.find(x => x.title === form.value.type.title)?.value ?? authTypes[0].value
  try {
    // Await the result of useFetch
    const {data, error} = await useFetch(uri.admin.rbac.add, {body: form.value, method: props.isUpdate?"PATCH":"POST"});
    if (error) {
      errorMessage.value = error.message;
      return;
    }
      successMessage.value = 'create successful!';
      toast($t('message.create-successfully'), {
        theme: "auto",
        type: "success",
        dangerouslyHTMLString: false,
      });
      emit("onSuccess")
      close()
  } catch (err) {
    errorMessage.value = err.message || 'An unexpected error occurred.';
  } finally {
    loadingFlag.value = false;
  }
}


</script>

<template>
  <section>
    <BaseDialog
        :size="'lg'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="$t('button.create')"
        @close="close"
    >
        <Form class="w-full" id="registerForm" :validation-schema="validationSchemaRegister" @submit="register">
          <div class="p-3">
            <!-- Auth Name -->
            <InputText
                name="name"
                :has-label="true"
                :label="$t('label.name')"
                v-model="form.name"
                id="input-wizard-3"
                type="text"
            />

            <!-- Auth Type -->
            <div class="p-3">
              <BaseInputSelect
                  class="primary"
                  v-model="form.type"
                  name="type"
                  :has-label="true"
                  :title="$t('label.type')"
                  deselect-label=""
                  :is-multiple="false"
                  :id="'input-wizard-3'"
                  track-by="value"
                  label="title"
                  :options="authTypes"
                  :searchable="false"
                  :allow-empty="false"
                  :is-preselect-first="true"
              />
            </div>
          </div>
        </Form>

      <template v-slot:footer>
        <free-style-shimmer width="100%" height="25px" class="w-full" v-if="loadingFlag"/>
        <div class="flex col-md-12 items-end justify-end gap-2" v-else>
          <Button variant="outline-secondary" @click="close" size="sm" class="p-3 shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
          <Button variant="primary" size="sm" form="registerForm" class="p-3 shadow-md justify-end items-end">
            {{ $t('button.create') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
  </section>
</template>

<style scoped>

</style>